export default __webpack_public_path__ + "static/media/spoc_man.8e5de8d1.svg";